<template>
  <div id="organization-mode" class="flex min-h-screen">
    <OrgSidebar />

    <div class="flex-1 min-w-0 flex flex-col pb-16 md:pb-0">
      <div v-if="settingsPage" class="flex-1 min-h-screen bg-gray-50 dark:bg-[#0d1117] px-5 md:px-12 lg:px-20 xl:px-32 mx-auto w-full xl:max-w-[85rem]">
        <OrganizationSettingsIndex />
      </div>
      <router-view v-else />
    </div>
  </div>
</template>

<script setup>
import { computed, onMounted, onUnmounted } from 'vue'
import { useRoute } from 'vue-router'
import { orgStore } from 'controllers/vue_components/organizations/store'
import OrgSidebar from 'controllers/vue_components/organizations/OrgSidebar.vue'
import OrganizationSettingsIndex from 'controllers/vue_components/organizations/settings'

const props = defineProps({
  current_user_json: { type: String, default: '{}' },
  current_org_json: { type: String, default: '{}' },
  current_org_social_libraries_json: { type: String, default: '{}' },
})

const store = orgStore()
const route = useRoute()

const settingsPage = computed(() => {
  const p = route.path
  return p.includes('/organizations/') && (
    p.includes('/profile') ||
    p.includes('/account') ||
    p.includes('/plan') ||
    p.includes('/members') ||
    p.includes('/developers')
  )
})

let notifInterval = null

store.$patch({ current_user: JSON.parse(props.current_user_json) })
store.$patch({ current_org: JSON.parse(props.current_org_json) })
store.$patch({ current_org_social_libraries: JSON.parse(props.current_org_social_libraries_json) })
store.fetchUserRoleInOrg()
store.fetchOrgMembers()
store.fetchNotificationsStats()
store.fetchUserOrganizations()

onMounted(() => {
  notifInterval = setInterval(() => store.fetchNotificationsStats(), 15000)
})

onUnmounted(() => {
  clearInterval(notifInterval)
})
</script>
